import styled, {css} from 'styled-components'

export default styled.div`

  ${props => props.width && css`
    width: ${props.width};
  `}

  ${props => props.height && css`
    height: ${props.height};
  `}

  ${props => props.minWidth && css`
    min-width: ${props.minWidth};
  `}

  ${props => props.minHeight && css`
    min-height: ${props.minHeight};
  `}

  ${props => props.maxWidth && css`
    max-width: ${props.maxWidth};
  `}

  ${props => props.maxHeight && css`
    max-height: ${props.maxHeight};
  `}

  ${props => props.fixed && css`
    position: fixed;
  `}

  ${props => props.absolute && css`
    position: absolute;
  `}

  ${props => props.top && css`
    top: ${props.top};
  `}

  // bottom: ${props => props.bottom ? props.bottom : "initial"};
  // right: ${props => props.right ? props.right : "initial"};
  // top: ${props => props.top ? props.top : "initial"};
  // left: ${props => props.left ? props.left : "initial"};

  ${props => props.zIndex && css`
    z-index: ${props.zIndex};
  `}

  ${props => props.border && css`
    border: ${props.theme.borderStyle};
  `}

  ${props => props.border && css`
    border: ${props.theme.borderStyle};
  `}



  ${props => props.padding && css`
    padding: ${props.padding};
  `}

  ${props => props.hidden && css`
    opacity: 0;
    touch-events: none;
  `}

  ${props => props.name && css`
    grid-area: ${props.name};
  `}

  ${props => props.textAlign && css`
    text-align: ${props.textAlign};
    `}

  ${props => props.sticky && css`
    position: sticky;
    top: ${props.sticky};
  `}

  ${props => props.blend && css`
    mix-blend-mode: ${props.blend};
  `}

  ${props => props.margin && css`
    margin: ${props.margin};
  `}
  ${props => props.marginBottom && css`
    margin-bottom: ${props.marginBottom} !important;
  `}

  @media (max-width: ${props => props.theme.small}) {
    ${props => props.smPosition && css`
      top: initial;
      position: ${props.smPosition};
    `}
  }

  ${props => props.mobile && css`
    @media (max-width: ${props.theme.small}) {
      ${props.mobile}
    }
  `}
`



// WEBPACK FOOTER //
// ./src/shared/Div.js